module.exports = __webpack_public_path__ + "img/cc-circle-2.8cde260a.png";